// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/message/v1/base.proto (package social.wssocial.entity.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message social.wssocial.entity.message.v1.StreamChannel
 */
export const StreamChannel = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.StreamChannel",
  () => [
    { no: 1, name: "scope", kind: "enum", T: proto3.getEnumType(StreamChannel_Scope) },
    { no: 2, name: "category", kind: "enum", T: proto3.getEnumType(StreamChannel_Category) },
    { no: 3, name: "identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.StreamChannel.Scope
 */
export const StreamChannel_Scope = /*@__PURE__*/ proto3.makeEnum(
  "social.wssocial.entity.message.v1.StreamChannel.Scope",
  [
    {no: 0, name: "SCOPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SCOPE_USER", localName: "USER"},
    {no: 2, name: "SCOPE_COMPANY", localName: "COMPANY"},
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.StreamChannel.Category
 */
export const StreamChannel_Category = /*@__PURE__*/ proto3.makeEnum(
  "social.wssocial.entity.message.v1.StreamChannel.Category",
  [
    {no: 0, name: "CATEGORY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CATEGORY_IDEAS", localName: "IDEAS"},
    {no: 2, name: "CATEGORY_REPORTS", localName: "REPORTS"},
    {no: 3, name: "CATEGORY_PREDICTIONS", localName: "PREDICTIONS"},
    {no: 4, name: "CATEGORY_POLLINGS", localName: "POLLINGS"},
    {no: 5, name: "CATEGORY_CHARTS", localName: "CHARTS"},
    {no: 6, name: "CATEGORY_NOTES", localName: "NOTES"},
    {no: 7, name: "CATEGORY_NEWS", localName: "NEWS"},
    {no: 8, name: "CATEGORY_REPLIES", localName: "REPLIES"},
    {no: 9, name: "CATEGORY_LIKED", localName: "LIKED"},
    {no: 10, name: "CATEGORY_SAVED", localName: "SAVED"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.ResearchChannel
 */
export const ResearchChannel = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.ResearchChannel",
  () => [
    { no: 1, name: "scope", kind: "enum", T: proto3.getEnumType(ResearchChannel_Scope) },
    { no: 2, name: "identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.ResearchChannel.Scope
 */
export const ResearchChannel_Scope = /*@__PURE__*/ proto3.makeEnum(
  "social.wssocial.entity.message.v1.ResearchChannel.Scope",
  [
    {no: 0, name: "SCOPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SCOPE_COMPANY", localName: "COMPANY"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Channel
 */
export const Channel = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.Channel",
  () => [
    { no: 1, name: "chatroom", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 2, name: "roomlist", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "streams", kind: "message", T: StreamChannel, repeated: true },
    { no: 4, name: "researches", kind: "message", T: ResearchChannel, repeated: true },
  ],
);

